import AuthorizationWrapper, {
  authFnAllowAdminImplementationManagerOrSASupervisor,
} from '@product-framework/components/AuthorizationWrapper';
import { FORM_ACTION, getRoutes } from '@ui-framework/index';
import ClaimPaymentImportList from './pages/list/index';
import BatchFileImportRowsDetail from './pages/details/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import ClaimPaymentImportListStore from './store/index';

const Pages = ProtectedRoute => ({
  ClaimPaymentImportList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ClaimPaymentImportList}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowAdminImplementationManagerOrSASupervisor],
      }}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
  BatchFileImportRowsDetail: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={BatchFileImportRowsDetail}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowAdminImplementationManagerOrSASupervisor],
      }}
      componentProps={{ action: FORM_ACTION.LIST }}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    claimPaymentImportListStore: new ClaimPaymentImportListStore(rootStore),
  },
];

export { ClaimPaymentImportList, BatchFileImportRowsDetail, routes, stores };
